<template>
  <div>
    <button class="btn btn-success" @click.prevent="openTab()">
      Descargar comprimido
    </button>
    <br /><br />
    <AnnexedFileTechnical />

    <Local v-if="['OICC'].includes(activity)" :disabled="disabled" />

    <TestEquipment
      v-if="['OICC', 'OEAP'].includes(activity)"
      :disabled="disabled"
    />

    <ProfTestInter
      v-if="['OICC', 'OEAP'].includes(activity)"
      :disabled="disabled"
      :activity="activity"
    />

    <rehearsal-activities-table
      v-if="['OICC', 'OEAP'].includes(activity)"
      title="PERSONAL QUE EJECUTA ACTIVIDADES  DE ENSAYO"
      tableId="rehearsal-activities-table"
      modalTitle="Añadir personal"
      editModalTitle="Editar personal"
      :activity="activity"
      :disabled="disabled"
    />

    <subcontractors-table
      v-if="['OEAP'].includes(activity)"
      title="Listado de Subcontratistas"
      tableId="subcontractors-table"
      modalTitle="Añadir subcontratista"
      editModalTitle="Editar subcontratista"
      :activity="activity"
      :disabled="disabled"
    />
  </div>
</template>

<script>
export default {
  computed: {
    activity() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.accreditation_activity.code
        : null;
    },

    disabled() {
      return (
        this.$store.state.accreditation.app != null &&
        this.$store.state.accreditation.app.status.code != "100"
      );
    },
  },

  methods: {
    openTab() {
      let w;
      w = window.open(
        `/annexes/download?accAppId=${this.$store.state.accreditation.id}`,
        "_blank"
      );
      w.focus();
    },
  },
};
</script>